/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        //OffCanvas
      	jQuery(document).ready(function($) {
      		$('html').offcanvas();
      		$('.scrollme').sdc395_scrollme($('.animateme'));
      	});
      	jQuery(document).ready(function($){
            $('.flexslider').flexslider({
      	    animation: 'fade',
      	    directionNav: false,
      	    controlNav: false,
      	    animationLoop: true,
      	    animationSpeed: 1000
      	  });
          });
      	// Superfish menu
        jQuery(document).ready(function($) {
      		$('.sf-menu').superfish({
            cssArrows:  true,
            disableHI:  false
          });
      	});
      	$('#nav li a').click(function () {
              window.location = $(this).attr('href');
              return false;
          });
      	// Fancy Box
      	jQuery(document).ready(function($) {
      		$('a.fancy-box').fancybox({
      			//'transitionIn'		:	'elastic',
      			//'transitionOut'		:	'elastic',
      			'speedIn'			:	600,
      			'speedOut'			:	200,
      			'overlayShow'		:	true,
      			'hideOnOverlayClick': 	true,
      			'centerOnScroll'	:   true,
      		});
      	});
      	// imagesLoaded for Masonry gallery
      	var $container = $('.js-masonry').masonry();
      	// layout Masonry again after all images have loaded
      	$container.imagesLoaded( function() {
      	  $container.masonry();
      	});
      },
      finalize: function() {
      // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // About us page, note the change from about-us to about_us.
    'gallery': {
      init: function() {
        // imagesLoaded for Masonry gallery
        var $container = $('.js-masonry').masonry();
        // layout Masonry again after all images have loaded
        $container.imagesLoaded( function() {
          $container.masonry();
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
